import "./css/CrmHeader.css";

export default function CustomerHeader({ headerName, showActions = true }) {
    return (
        <div className="page-header">
            <h2>{headerName}</h2>

            {showActions ? (
                <div className="page-header-right">
                    <div className="search-box">
                        <input type="text" placeholder="Search..." />
                    </div>

                    <button className="icon-btn">
                        🔔
                    </button>

                    <div className="avatar">JD</div>
                </div>
            ) : null}
        </div>
    );
}
